// removed by extract-text-webpack-plugin
module.exports = {"W-0":"#FFFFFF","circle":"Gb6dcdb G316e3b","iconMobile":"G5a375d Gb6dcdb G316e3b Ge743c3 G84889d","arrowDown":"G15ea6e Gb69063 Gfc1db7","arrowUp":"Ga5a020 Gb69063 G455107"};